import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import { Form } from '@ant-design/compatible';
import RejectCancelDeliveryDispatchModal from '../../../../views/order/common/modal/RejectCancelDeliveryDispatchModal';
import withModal from '../../../../lib/hoc/withModal';
import { orderActions } from '../../../../store/modules/order';
import { ORDER_DELIVERY_TYPE } from '../../../../constants/service/app/orderConstants';
import { setIfNull, setTrim } from '../../../../lib/common';

class RejectCancelDeliveryDispatchModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      /**
       *  택배 방법
       */
      deliveryDispatchType: ORDER_DELIVERY_TYPE.PARCEL_DELIVERY,
      /**
       *  택배사
       */
      deliveryDispatchAgentId: null,
      /**
       *  송장번호
       */
      deliveryInvoiceNumber: null,
      /**
       *  배송지
       */
      address: this.props.data.address,
      /**
       *  배송 메시지
       */
      message: this.props.data.shippingMessage,
    };
  }

  /**
   * 모달 닫기 || 데이터 초기화
   */
  closeModal = () => {
    const { toggleModal } = this.props;
    toggleModal({
      name: 'rejectCancelDeliveryDispatchModal',
    });
  };

  /**
   *  취소 거부 -> 발송 처리
   */
  onSubmit = () => {
    const { form, data, rejectOrderCancelDeliveryDispatch } = this.props;
    const { orderItemId, recipientPhone, recipientName } = data;
    const { deliveryDispatchType, deliveryDispatchAgentId, deliveryInvoiceNumber, address } = this.state;

    form.validateFields((err) => {
      if (err) return;

      if (!address.line1) {
        message.error('배송지 주소를 입력하지 않았습니다.');
        return;
      }

      rejectOrderCancelDeliveryDispatch({
        orderItemId,
        deliveryType: deliveryDispatchType,
        deliveryAgentId: deliveryDispatchAgentId,
        invoiceNumber: setTrim(deliveryInvoiceNumber),
        address,
        message: setIfNull(setTrim(this.state.message)),
        recipientPhone,
        recipientName,
      });

      this.closeModal();
    });
  };

  /**
   * 데이터 변경
   */
  setData = (data) => {
    this.setState({
      [data.name]: data.value,
    });
  };

  setAddressLine2 = (line2) => {
    this.setState({
      ...this.state,
      address: {
        ...this.state.address,
        line2,
      },
    });
  };

  render() {
    const { isOpen, form, data } = this.props;

    return (
      <RejectCancelDeliveryDispatchModal
        form={form}
        isOpen={isOpen}
        data={data}
        {...this.state}
        onSubmit={this.onSubmit}
        setData={this.setData}
        closeModal={this.closeModal}
        setAddressLine2={this.setAddressLine2}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.order.rejectCancelDeliveryDispatchModal.isOpen,
    data: state.order.rejectCancelDeliveryDispatchModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: orderActions.toggleModal,
  rejectOrderCancelDeliveryDispatch: orderActions.rejectOrderCancelDeliveryDispatch,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withModal()(Form.create({})(RejectCancelDeliveryDispatchModalContainer)));
